export const ROUTE_PATH = '/sales-turnover';

export const FEATURE_NAME = 'salesTurnoversPage';
